import aswapInstance from './aswap/ASwap'
import Controller from './aswap/Controller'
import ControllerImgLoad from './aswap/ControllerImgLoad'
import View from './aswap/View'
import WebflowView from './aswap/WebflowView'
import WebflowListView from './aswap/WebflowListView'
// Bootstrap v5 helper
import bootsrap5 from './bootstrap/v5/Bootstrap5'
// showup
import scrollController from './showup/ScrollController'
import showUp from './showup/ShowUp'
import { getWebflowAnimationProps, getWebflowProps, getParallaxProps, parseProps } from './lib/dataTweenParser'
import { getScrollMagicSceneProps } from './lib/dataScrollMagicParser'

export default {
  aswap: aswapInstance,
  Controller,
  ControllerImgLoad,
  View,
  WebflowView,
  WebflowListView,
  // boottstrap
  bootsrap5,
  // showup
  scrollController,
  showUp,
  // lib
  getWebflowAnimationProps,
  getWebflowProps,
  getParallaxProps,
  parseProps,
  getScrollMagicSceneProps
}